export default {
    title: "Encuesta enviada",
    header: "@:views.survey.submitted.title",
    message: "Gracias por tus comentarios.",
}